<template>
  <div>
    <div v-if="data.length > 0">
      <div v-if="headerTop != null" class="center_head" :style="{ 'background-image': 'url('+ headerBg +')' }">
        <div class="center_header_data1">
          <img :src="headerTop" style="width: 100%"/>
        </div>
      </div>
      <div class="center_list" v-for="(item, index) in data" :key="index">
        <img :src="item.img"/>
        <div class="center_list_data">
          <div class="title">{{ item.name }}</div>
          <div class="line"></div>
          <div class="datas">
            <div class="pars">
              <div class="d1" v-for="(par, pIndex) in JSON.parse(item.parameters)" :key="pIndex">{{ par.key }}： {{ par.value }}</div>
            </div>
            <div class="funs">
              <div class="d1">功能：</div>
              <div class="d1" v-for="(fun, fIndex) in JSON.parse(item.funs)" :key="fIndex">{{ fIndex + 1 }}、{{ fun.value }}</div>
            </div>
            <div class="video">
              <div v-if="item.video != null">
                <my-video :src="item.video" :statusBtnSize="[32, 32]"></my-video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MyVideo from '../../../components/video/MyVideo'
export default {
  components: {
    MyVideo
  },
  data () {
    return {
      // headerData: null,
      data: [],
      headerBg: null,
      headerTop: null
    }
  },
  methods: {
    setData (datas, headerBg, headerTop) {
      let obj = JSON.parse(JSON.stringify(datas))
      // this.headerData = obj[0]
      // obj.splice(0, 1)
      this.data = obj
      this.headerBg = headerBg
      this.headerTop = headerTop
    }
  }
}
</script>
<style scoped lang="scss">
  .center_head {
    background: #d7d7d7;
    /*height: 500px;*/
    overflow: hidden;
    margin-bottom: 45px;
    .center_header_data1 {
      width: 1200px;
      margin: auto;
      p {
        font-size: 19px;
        font-weight: bold;
        color: #333333;
        margin-top: 30px;
        letter-spacing:1px;
      }
    }
    .center_header_data {
      width: 1200px;
      margin: auto;
      p {
        font-size: 19px;
        font-weight: bold;
        color: #333333;
        margin-top: 30px;
        letter-spacing:1px;
      }
      .content {
        display: flex;
        img {
          height: 380px;
        }
        .video {
          height: 270px;
          width: 480px;
          margin-left: 130px;
          margin-top: 25px;
        }
        .text {
          margin-left: 130px;
          /*color: #343434;*/
          font-weight: 600;
        }
      }
    }
  }
  .center_list {
    width: 1200px;
    margin: auto;
    display: flex;
    padding-bottom: 50px;
    img {
      height: 210px;
    }
    .center_list_data {
      margin-left: 50px;
      flex:1;
      .title {
        font-weight: bold;
        color: #333333;
        font-size: 18px;
      }
      .line {
        background: #d7d7d7;
        height: 1px;
        margin-top: 5px;
      }
      .datas {
        font-weight: 600;
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        .pars {
          width: 310px;
        }
        .funs {
          width: 330px;
        }
        .d1 {
          margin-bottom: 6px;
        }
        .more {
          color: #2440b3;
          cursor: pointer;
        }
        .video {
          width: 160px;
          height: 90px;
        }
      }
    }
  }
  //进度条
  video::-webkit-media-controls-timeline {
    display: none;
  }
  //观看的当前时间
  video::-webkit-media-controls-current-time-display {
    display: none;
  }
  //剩余时间
  video::-webkit-media-controls-time-remaining-display {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/CenterType.vue